import { Button, Stack } from "@mui/material";
import { fillRouteWithSlugs } from "@utils";
import { Link as RouterLink } from "react-router-dom";
import { ROUTES, ROUTE_SLUGS } from "src/config/navigation/routes";

type Props = {
  orgId: string;
  active: "task-definitions" | "roadmap-cards";
};

export const AdminConfigurationNav = ({ orgId, active }: Props) => {
  const taskDefinitionsRoute = ROUTES.ADMIN_TASK_DEFINITIONS
    ? fillRouteWithSlugs(ROUTES.ADMIN_TASK_DEFINITIONS, {
        [ROUTE_SLUGS.ORG_ID]: orgId,
      })
    : "";
  const roadmapCardsRoute = ROUTES.ADMIN_ROADMAP_CARDS
    ? fillRouteWithSlugs(ROUTES.ADMIN_ROADMAP_CARDS, {
        [ROUTE_SLUGS.ORG_ID]: orgId,
      })
    : "";

  return (
    <Stack direction="row" spacing={1}>
      <Button
        variant={active === "task-definitions" ? "contained" : "outlined"}
        component={RouterLink}
        to={taskDefinitionsRoute}
        size="small"
      >
        Task Definitions
      </Button>
      <Button
        variant={active === "roadmap-cards" ? "contained" : "outlined"}
        component={RouterLink}
        to={roadmapCardsRoute}
        size="small"
      >
        Roadmap Cards
      </Button>
    </Stack>
  );
};
